import AbstractApi from '@/api/abstracts/AbstractApi'
import QueryParams from '@/utilities/gridManager/QueryParams'
import httpClient from '@/utilities/service/httpClient'
// eslint-disable-next-line prettier/prettier
import type { EquipmentListPayloadType } from '@/api/types/request/EquipmentListPayloadType'
import type { EquipmentListType } from '@/api/types/response/EquipmentListType'

/**
 * @property string apiEnd /api/sales/bid/equipments/{bidNumber}
 */
export default class EquipmentsApi extends AbstractApi {
  fetchAll(payload: EquipmentListPayloadType): Promise<EquipmentListType> {
    return httpClient.get(`${this.apiEnd}?${new QueryParams<EquipmentListPayloadType>(payload).toString()}`)
  }
}
